import {StepItemStatus} from 'ui-library/StepNav';

import {FileListingGraphQL} from '../../../graphql-fragments/files/__generated/FileListingGraphQL';

export enum StepKey {
  ATTACH = 'ATTACH',
  PROCESS = 'PROCESS',
}

export interface ImportConnectionFilesModalState {
  statusByStep: {[key in StepKey]: StepItemStatus};
  currentStepKey: StepKey;
  selectedRowIndices: Set<number>;
  selectedProcessConnectionFiles: Array<FileListingGraphQL>;
  isImporting: boolean;
  connectionFiles: Array<FileListingGraphQL>;
}

export const INITIAL_STATE: ImportConnectionFilesModalState = {
  statusByStep: {
    [StepKey.ATTACH]: StepItemStatus.UNVISITED,
    [StepKey.PROCESS]: StepItemStatus.UNVISITED,
  },
  currentStepKey: StepKey.PROCESS,
  selectedRowIndices: new Set(),
  selectedProcessConnectionFiles: [],
  isImporting: false,
  connectionFiles: [],
};

export enum ConnectionFileStatus {
  UPLOADED = 'UPLOADED',
  NOT_UPLOADED = 'NOT_UPLOADED',
  ARCHIVED = 'ARCHIVED',
}

export const FILE_STATUS_TO_TEXT: {[status in ConnectionFileStatus]: string} = {
  [ConnectionFileStatus.UPLOADED]: 'Available',
  [ConnectionFileStatus.ARCHIVED]: 'Archived',
  [ConnectionFileStatus.NOT_UPLOADED]: 'Pending',
};

// These statuses come from PipelineDataUploadStatus as defined data_frame.graphql,
// but we may not use every status there in the UI.
export const MAP_FILE_UPLOAD_STATUS_TO_CONNECTION_FILE_STATUS: Record<string, ConnectionFileStatus> = {
  NOT_UPLOADED: ConnectionFileStatus.NOT_UPLOADED,
  SUCCEEDED: ConnectionFileStatus.UPLOADED,
};
